import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(0, 3, 3),

    '& .notes': {
      '&-ammount': {
        display: 'flex',
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(2),
      },
      '&-load-more': {
        display: 'flex',
        margin: theme.spacing(3, 0),
      },
      '&-new': {
        '&-container': {
          margin: theme.spacing(3, 0, 0),
        },
        '&-input': {
          width: '100%',
        },
        '&-actions': {
          marginTop: theme.spacing(1),
          display: 'flex',
          justifyContent: 'flex-end',
        },
      },
    },

    '& .skeleton-note': {
      '&-input': {
        backgroundColor: theme.palette.custom.surface[1],
        borderRadius: theme.shape.borderRadius,
        height: theme.spacing(10),
        marginTop: theme.spacing(3),
      },
      '&-item': {
        '&-container': {
          display: 'flex',
          alignItems: 'flex-start',
          padding: theme.spacing(3, 0, 0),
        },
        '&-avatar': {
          marginRight: theme.spacing(1),
          width: theme.spacing(5),
          height: theme.spacing(5),
        },
        '&-ballon': {
          flexGrow: 1,
          backgroundColor: theme.palette.custom.surface[1],
          borderRadius: theme.shape.borderRadius,
          padding: theme.spacing(2),
          height: theme.spacing(10),
        },
      },
    },
  },
  input: {
    ...theme.typography.body2,
    minHeight: theme.spacing(10),
    alignItems: 'flex-start',
  },
  btn: {
    ...theme.typography.caption,
    textTransform: 'none',
  },
}));

export default styles;
